import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["emailsTemplate", "emailsForm", "phonesTemplate", "phonesForm", "fieldRow"]

  connect() {
    this.emailTemplate = this.hasEmailsTemplateTarget ? this.emailsTemplateTarget.innerHTML : ""
    this.phoneTemplate = this.hasPhonesTemplateTarget ? this.phonesTemplateTarget.innerHTML : ""

    if (this.hasEmailsTemplateTarget) this.emailsTemplateTarget.innerHTML = ""
    if (this.hasPhonesTemplateTarget) this.phonesTemplateTarget.innerHTML = ""
  }

  addEmail(event) {
    event.preventDefault()
    if (!this.hasEmailsFormTarget) return
    this.emailsFormTarget.insertAdjacentHTML("beforeend", this.emailTemplate)
    this.reindex(this.emailsFormTarget)
    const added = this.emailsFormTarget.lastElementChild
    const input = added?.querySelector("input[type='email'], input[type='text']")
    if (input) input.focus()
  }

  addPhone(event) {
    event.preventDefault()
    if (!this.hasPhonesFormTarget) return
    this.phonesFormTarget.insertAdjacentHTML("beforeend", this.phoneTemplate)
    this.reindex(this.phonesFormTarget)
    const added = this.phonesFormTarget.lastElementChild
    const input = added?.querySelector("input[type='text']")
    if (input) input.focus()
  }

  removeField(event) {
    const row = event.target.closest(".fields_row")
    if (!row) return
    const destroy = row.querySelector("input.destroy")
    if (destroy) destroy.value = "1"
    row.style.display = "none"
  }

  reindex(container) {
    container.querySelectorAll(".fields_row").forEach((row, i) => {
      row.querySelectorAll("input, select, textarea, label").forEach((el) => {
        if (el.id) el.id = el.id.replace(/_\d+_/g, `_${i}_`)
        if (el.name) el.name = el.name.replace(/\[\d+\]/g, `[${i}]`)
        const forAttr = el.getAttribute("for")
        if (forAttr) el.setAttribute("for", forAttr.replace(/_\d+_/g, `_${i}_`))
      })
    })
  }
}
